/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPreferences = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M13 11v11h-2V11zm-5 2v2H6v7H4v-7H2v-2zm14 2v2h-2v5h-2v-5h-2v-2zM20 2v11h-2V2zM6.001 2v9H4V2zM13 2v5h2v2H9V7h2V2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgPreferences as Preferences };
